<script setup lang="ts">
defineOptions({
  name: 'HomePage',
});

const { $storyblokLivePreview } = useNuxtApp();
const loading = ref({
  loading: true,
});
const classNameRef = ref(['']);
const route = useRoute();

const { getCmsStory, trackPageView, cmsStoryModelRef } = useMopCms('home');
const { initTransition } = useMopPageTransitionClient();
const { handleHeadForCmsPage, getHomepageSchemas } = useMopSeo();
initTransition(classNameRef, loading);

useAsyncData(
  () => getAsyncDatatCacheId(route),
  async () => {
    await getCmsStory('/');
    loading.value.loading = false;
    return null;
  },
);

onMounted(() => {
  trackPageView('Home');
});

const seoHeadRef = computed(() => {
  if (!cmsStoryModelRef.value.isInitialized() || cmsStoryModelRef.value.hasError()) {
    return;
  }
  return handleHeadForCmsPage(cmsStoryModelRef.value);
});

useHead({
  title: () => seoHeadRef.value?.title,
  meta: () => seoHeadRef.value?.meta,
  link: () => seoHeadRef.value?.link,
  script: getHomepageSchemas(),
} as any);

$storyblokLivePreview.initStoryListener('Storyblok', cmsStoryModelRef);
</script>

<template>
  <div :class="['home', 'transition', ...classNameRef]">
    <MopPageLoad :class="classNameRef" />
    <div class="transition-content">
      <MopCmsContentElementsSlot
        v-if="!loading.loading"
        id="homepage__content"
        class="thank-you__content-top"
        :elements="cmsStoryModelRef.getContentElements()"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.home {
  position: relative;
  margin-bottom: $space60;
}
</style>
